export default __webpack_public_path__ + "static/media/emailLogo.f2bcc439.svg";